export { osMeta } from './meta';



// WEBPACK FOOTER //
// ../../../../src/metas/os/index.ts